import { useTranslation } from "react-i18next";
import { Button } from "@nexus/ui";

interface WizardNavProps {
  step: number;
  canAdvance: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
  onCancel: () => void;
}

export function WizardNav({
  step,
  canAdvance,
  isSubmitting,
  onBack,
  onNext,
  onCancel,
}: WizardNavProps) {
  const { t } = useTranslation();
  const isFirst = step === 1;
  const isLast = step === 3;

  return (
    <div className="flex items-center justify-end gap-2 border-t border-border bg-background px-6 py-4">
      {isFirst ? (
        <Button type="button" variant="ghost" onClick={onCancel} disabled={isSubmitting}>
          {t("marketplace.wizard.actions.cancel")}
        </Button>
      ) : (
        <Button type="button" variant="outline" onClick={onBack} disabled={isSubmitting}>
          {t("marketplace.wizard.actions.back")}
        </Button>
      )}
      <Button type="button" onClick={onNext} disabled={!canAdvance || isSubmitting}>
        {isSubmitting
          ? t("marketplace.wizard.actions.connecting")
          : isLast
            ? t("marketplace.wizard.actions.submit")
            : t("marketplace.wizard.actions.continue")}
      </Button>
    </div>
  );
}
